import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-065d6e9f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "backgroud" }
const _hoisted_2 = ["src"]

import { withDefaults } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'CorporateCulture',
  props: {
    logo: { default: '' }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      src: _ctx.logo,
      alt: "banner",
      class: "w-[100%]"
    }, null, 8, _hoisted_2)
  ]))
}
}

})